import { render, staticRenderFns } from "./ReceivedProductsPanel.vue?vue&type=template&id=0b7e95ee&"
import script from "./ReceivedProductsPanel.vue?vue&type=script&lang=ts&"
export * from "./ReceivedProductsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports